import axiosInstance from './axios';
import type { Vehicle } from './vehicles.api';

export interface Ticket {
    id: string;
    numero: string;
    vehiculoId: string;
    operadorId: string;
    companyId: string;
    espacioId?: string;
    status: 'ACTIVO' | 'CERRADO' | 'CANCELADO';
    createdAt: string;
    updatedAt: string;

    // Relations based on backend include
    vehiculo?: Vehicle;
    operador?: { nombre: string; email?: string };
    espacio?: { nombre: string };
    company?: { nombre: string };
}

export const getTicketsHistory = async (): Promise<Ticket[]> => {
    const response = await axiosInstance.get<Ticket[]>('/tickets');
    return response.data;
};

export const getTicketById = async (id: string): Promise<Ticket> => {
    const response = await axiosInstance.get<Ticket>(`/tickets/${id}`);
    return response.data;
};

export const cancelTicket = async (id: string): Promise<Ticket> => {
    const response = await axiosInstance.patch<Ticket>(`/tickets/${id}/cancel`);
    return response.data;
};
